import { getActiveTraceHttpRequestHeaders } from '@atlaskit/react-ufo/experience-trace-id-context';
import { setMark, getTraceId } from '@atlassian/jira-early-script-utils/src/index.tsx';
import { FetchError } from '@atlassian/jira-early-script-utils/src/types.tsx';

type FetchDataParams = {
	url: string;
	body?: string;
	method?: string;
	headers?: Record<string, string | string[]>;
};

/**
 * Simplified fetch function to be used in early scripts.
 */
export const fetchData = <T,>({
	url,
	body,
	method = 'GET',
	headers,
}: FetchDataParams): Promise<T> => {
	setMark('jira.fe-spa.jpd.early-preload:start');
	return fetch(url, {
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
			Accept: ['application/json', 'text/javascript'].join(','),
			...getActiveTraceHttpRequestHeaders(),
			...headers,
		},
		method,
		body,
	}).then((response) => {
		setMark('jira.fe-spa.jpd.early-preload:end');
		if (!response.ok) {
			const { status } = response;
			return response.text().then((str) => {
				const traceId = getTraceId(response);
				throw new FetchError(status, str, traceId || undefined);
			});
		}
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return response.json() as T;
	});
};
